import { Controller } from '@hotwired/stimulus';

const TENS = [
  'twenty',
  'thirty',
  'forty',
  'fifty',
  'sixty',
  'seventy',
  'eighty',
  'ninety'
];
const ONES = [
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine'
];

export const numberInWords = (number: number): string => {
  const tens = TENS[Math.floor(number / 10) - 2];
  const ones = number % 10;

  return ones === 0 ? tens : `${tens}-${ONES[ones - 1]}`;
};

// The Wild Steps parental check on the web: type a number written in words (twenty to ninety-nine), which a parent
// can do and a young child can't. The challenge only goes back to the server once the answer is right; a wrong
// answer quietly picks a new number.
export default class ParentalCheckController extends Controller<HTMLFormElement> {
  public static readonly targets = ['words', 'answer', 'challenge'];

  public static readonly values = { challenge: String };

  declare public readonly wordsTarget: HTMLElement;
  declare public readonly answerTarget: HTMLInputElement;
  declare public readonly challengeTarget: HTMLInputElement;

  declare private readonly challengeValue: string;

  private number = 0;

  public connect(): void {
    this._pickNumber();
  }

  public check(event: SubmitEvent): void {
    if (this.answerTarget.value.trim() === String(this.number)) {
      this.challengeTarget.value = this.challengeValue;

      return;
    }

    event.preventDefault();
    this.answerTarget.value = '';
    this._pickNumber();
  }

  // Never the same number twice in a row
  private _pickNumber(): void {
    let number = this.number;

    while (number === this.number) {
      number = 20 + Math.floor(Math.random() * 80);
    }

    this.number = number;
    this.wordsTarget.textContent = numberInWords(number);
  }
}
